import { dateToString, formatPrice, isMobileDevice } from "../../utils/Utils";
import BillboardCalendar from "../BillboardCalendar";

class ShoppingCartItem{
    constructor(data){
        this.main = null;
        
        this._data = data;

        this._initDom();

        if(data.days_available > 0){
          const buttons = this.main.querySelectorAll('.days_available_btn');
          buttons[buttons.length - 1].addEventListener('click', this._onClickDaysAvailableBtn.bind(this));
        }
        
        if (this.main.querySelector('.delete_btn')) {
          this.main.querySelector('.delete_btn').addEventListener('click', this._onClickDeleteBtn.bind(this));
        }
    }

    get data(){
        return this._data;
    }

    _onClickDeleteBtn(e){
        this.main.dispatchEvent(new CustomEvent('SHOPPING_CART_ITEM_REMOVE', {
            bubbles: true,
            detail: {
                item: this
            }    
        }));
    }

    _onClickDeletePackageBtn(e) {
      const packageId = e.target.closest('.package_holder').dataset.packageId;

      this.main.dispatchEvent(new CustomEvent('SHOPPING_CART_PACKAGE_REMOVE', {
          bubbles: true,
          detail: {
            package_id: packageId,
          }
      }));
    }

    _onClickDaysAvailableBtn(e){
        e.preventDefault();
        //BillboardCalendar.showAvailability(this._data.id, this._data.dateRange, this._data.exclusivity, this._data.brand_id, this._data.brand_category_id);
        BillboardCalendar.showAvailability(this._data.id, this._data.dateRange, this._data.exclusivity, null, this._data.brand_category_id, this._data.weekdays, true, this._data.package ? this._data.package.id : null);
    }

    _initDom(){
      let data = this._data;  
      
      let billboardUrl = `${BASE_URL}billboards/${data.slug}?date_range=${dateToString(data.dateRange.from)},${dateToString(data.dateRange.to)}`;

      if(data.brand_id != null){
        billboardUrl += `&brand_id=${data.brand_id}`;
      }

      if(data.brand_category_id != null){
        billboardUrl += `&brand_category_id=${data.brand_category_id}`;
      }

      let billboardLinkTarget = isMobileDevice() ? '_self' : '_blank';

      let totalDays = (data.dateRange.to.getTime() - data.dateRange.from.getTime())/(1000 * 3600 * 24) + 1;

      let html = /*html*/`<div class="shopping-cart__item ${data.days_available == 0 ? 'shopping-cart__item--not-available' : ''}">
        <div class="row no-gutters">
          <div class="col">
          ${(data.format ?
              /*html*/`
              <div class="mb-1">
                <div class="tag tag--size-3 tag--format p-0">${data.format.name}</div>
              </div>`
          :'')}
            <div class="shopping-cart__billboard-name">
              <span class="shopping-cart__billboard-name-text">
                <a href="${billboardUrl}" class="shopping-cart__billboard-link" target="${billboardLinkTarget}">
                  <span class="shopping-cart__billboard-name-text--inner-wrapper">
                    <span class="shopping-cart__billboard-name-text--inner">${data.name}</span>
                    
                    ${(data.is_prime ?
                        /*html*/`
                        <div class="mt-1">
                          <div class="tag tag--size-3 tag--prime">Prime</div>
                        </div>`
                    :'')}
                  </span>
                </a>
              </span>
            </div>
            
            <div class="shopping-cart__billboard-availability">
              <span class="shopping-cart__not-available">Not&nbsp;available</span>
              <a href="#" class="link days_available_btn">
                ${data.days_available} of ${totalDays} days available
                ${(data.exclusivity ? '<br> with exclusivity' : '')}
              </a>   
            </div>
            <div class="shopping-cart__billboard-period">${dateToString(data.dateRange.from, 'M d')} - ${dateToString(data.dateRange.to, 'M d')}</div>
          </div>
          <div class="col-auto d-flex flex-column ml-auto text-right align-items-end">
            ${(data.package ? '' : `<div><span class="shopping-cart__remove-item delete_btn"><i class="material-icons material-icons--type-outlined material-icons--size-3">delete</i></span></div>`)}
            <div class="shopping-cart__billboard-original-price mt-auto">${(data.original_price && data.original_price != data.price ? formatPrice(data.original_price) : '')}</div>
            <div class="shopping-cart__billboard-price">${formatPrice(data.price)}</div>
          </div>
        </div>
      </div>`;

      this.main = document.createElement('div');
      this.main.innerHTML = html;
      this.main = this.main.firstChild;
    }
}

export default ShoppingCartItem;